
import React, { useState } from 'react';

const Paginator = ({ index, length, onClick}) => {
    return <div >
            <div className="pagination">
                <div className="page-item">
                    {index > 0 ? <div className="page-link" onClick={() => onClick(index - 1)}><span >&laquo;</span></div>
                    :  <div className="page-link" ><span >&laquo;</span></div>
                    }
                </div>
                
                {index > 0 ? <div className="page-item" onClick={() => onClick(index - 1)}><div className="page-link" >{index}</div></div>: null}
                <div className="page-item active"><div className="page-link" >{index + 1}</div></div>
                {index < length - 1 ? <div className="page-item" onClick={() => onClick(index + 1)}><div className="page-link" >{index + 2}</div></div>: null}
                
                <div className="page-item">
                    {index < length - 1 ? <div className="page-link" onClick={() => onClick(index + 1)}><span >&raquo;</span></div>
                    :  <div className="page-link" ><span >&raquo;</span></div>
                    }
                </div>
            </div>
        </div>
}

export default Paginator